import { WithMainMenu } from "../../layouts/MainMenu";
import { SafeAreaView } from "../../layouts/SafeArea";
import { WithSupportZone } from "../../layouts/SupportZone/WithSupportZone";
import NavigatorView from "../../navigation/NavigatorView";
import { loggedInHomeRoute, loggedInNavigator } from "../../navigation/routes";
import RouteView from "../../navigation/RouteView";
import BriefEditorNavigator from "../BriefEditorNavigator";
import ContactsNavigator from "../ContactsNavigator";
import CreateProjectNavigator from "../CreateProjectNavigator";
import MailingNavigator from "../MailingNavigator";
import ProcessNavigator from "../ProcessNavigator";
import SettingsNavigator from "../SettingsNavigator";
import UsersNavigator from "../UsersNavigator";
import LoggedInHomeScreen from "./LoggedInHomeScreen";
import { useCurrentProject, useMe } from "./services/context";

export default function LoggedInNavigator() {
    useMe();
    useCurrentProject();
    return (
        <WithMainMenu>
            <SafeAreaView>
                <WithSupportZone>
                    <SafeAreaView>
                        <NavigatorView navigator={loggedInNavigator}>
                            <RouteView route={loggedInHomeRoute} component={LoggedInHomeScreen} />
                            <CreateProjectNavigator />
                            <ContactsNavigator />
                            <UsersNavigator />
                            <MailingNavigator />
                            <ProcessNavigator />
                            <SettingsNavigator />
                            <BriefEditorNavigator />
                        </NavigatorView>
                    </SafeAreaView>
                </WithSupportZone>
            </SafeAreaView>
        </WithMainMenu>
    );
}
